// extracted by mini-css-extract-plugin
export var link = "dk_D";